export default [
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/menu/order/order.vue'),
    meta: {
      pageTitle: 'مدیریت سفارش ها',
      action: 'show',
      resource: 'OrderManager',
    },
  },
]
